export const widgetName = "custom-widget";
export const widgetDisplayName = "Custom widget";
export const widgetCategory = "Custom widgets";
export const widgetSelector = "custom-widget";
export const widgetRuntimeSelector = "custom-widget-runtime";
export const widgetEditorSelector = "custom-widget-editor";
export const widgetIconClass = "widget-icon widget-icon-api-management";